<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Schedule Software Updates
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <v-date-picker v-model="picker" :events="schedule"></v-date-picker>
            <div style="text-align: center">{{picker}} - <b>{{countsByDay[picker] || 0}}<b?</div>
          </v-col>
          <v-col>
            <div>
              <i>Enter a serial number filter and press the search button.  The number of aligners that match your query will be presented for confirmation.</i>
            </div>
            <v-text-field
              placeholder="serial number filter"
              single-line
              v-model="filterSerialNumber"
              :append-icon="getSearchIcon()"
              @click:append="onSearchClicked"
              @input="onSearchInput"
            >
            </v-text-field>
            <div v-if="searchResults">
              <div style="font-size: 60px; text-align: center; margin-top: 10px"><b>{{searchResults.length}}</b></div>
              <div style="text-align: center; margin-top: 10px"><i>aligners found</i></div>
              <div v-if="searchResults && searchResults.length > 0" style="margin-top: 10px; color: green">
                <i>Click CONFIRM to schedule <b>{{searchResults.length}}</b> updates to be staged on {{picker}}.</i>
              </div>
              <div v-else style="margin-top: 10px; color: red">
                <i>No aligners match your serial number pattern.  Please try a different search.</i>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="indigo" class="white--text" @click="onConfirmClicked()" v-if="searchResults && searchResults.length > 0">Confirm</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClicked()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    schedule: Object,
    countsByDay: Object,
  },

  data() {
    return {
      picker: new Date().toISOString().substr(0, 10),
      filterSerialNumber: '',
      searching: false,
      searchResults: null,
    };
  },

  methods: {
    onCancelClicked() {
      this.filterSerialNumber = '';
      this.searchResults = null;
      this.$emit('close');
    },

    getSearchIcon() {
      return this.searching ? 'hourglass_empty' : 'search';
    },

    onSearchClicked() {
      const options = {
        method: 'GET',
        url: `/read/aligner_serial_numbers/v1?filterSerialNumber=${this.filterSerialNumber}`,
      };

      this.searching = true;

      this.axios(options)
        .then((res) => {
          this.searching = false;
          this.searchResults = res.data;
        })
        .catch((err) => {
          console.error(`--- search error ${err.response.status}, ${err.response.data}`);
          this.searching = false;
          this.searchResults = null;
        });
    },

    onSearchInput() {
      this.searchResults = null;
    },

    onConfirmClicked() {
      const options = {
        method: 'POST',
        url: '/create/schedule_serial_numbers/v1',
        data: {
          serialNumbers: this.searchResults,
          version: {
            semantic: this.$store.state.latestSoftwareVersion.semantic,
            meta: this.$store.state.latestSoftwareVersion.meta || '',
          },
          path: this.$store.state.latestSoftwareVersion.path,
          date: this.picker,
        },
      };

      this.axios(options)
        .then((res) => {
          this.filterSerialNumber = '';
          this.searchResults = null;
          this.$emit('close');
        })
        .catch((err) => {
          console.error('--- create schedule error');

          this.filterSerialNumber = '';
          this.searchResult = null;
          this.$emit('close');
        });
    },
  },
};
</script>
